·<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     总览
  +---------------------------------------------------------------------------------------
-->

<template>
  <div class="mt-md mb-md">

    <el-row :gutter="15">
      <el-col :span="16">
        <el-card v-loading="loading" shadow="never">
          <div class="front-line mb">接入点概览</div>
          <el-row :gutter="15">
            <el-col :span="10">
              <div class="bg-light radius5">
                <div class="pt pl pb pr">总数（个）</div>
                <div class="text-center font-4x text-primary" style="height: 69px;">{{ stat.total_num }}</div>
                <div class="text-center bg-primary text-white" role="button" style="line-height: 44px;" @click="$router.push('/ap/list')">前往管理</div>
              </div>
            </el-col>
            <el-col :span="10">
              <div class="block-item bg-light radius5" role="button" @click="$router.push('/ap/list?expire_day=' + threeMonth)">
                <span class="title">90天内到期</span>
                <span class="text-muted font-lg" :class="{ 'text-warning': stat.expired_in_ninety_days }">{{ stat.expired_in_ninety_days }}</span>
                <span class="ml text-muted">个</span>
              </div>
              <div class="block-item mt bg-light radius5" role="button" @click="$router.push('/ap/list?expire_day=' + oneMonth)">
                <span class="title">30天内到期</span>
                <span class="text-muted font-lg" :class="{ 'text-warning': stat.expired_in_thirty_days }">{{ stat.expired_in_thirty_days }}</span>
                <span class="ml text-muted">个</span>
              </div>
              <div class="block-item mt bg-light radius5" role="button" @click="$router.push('/ap/list?status=4')">
                <span class="title">待续费</span>
                <span class="text-muted font-lg" :class="{ 'text-warning': stat.expired }">{{ stat.expired }}</span>
                <span class="ml text-muted">个</span>
                <span v-if="stat.expired" class="pull-right"><el-button size="mini" type="danger" round @click="rechargeExpired">立即充值</el-button></span>
              </div>
            </el-col>
            <el-col :span="4">
              <div class="bg-light radius5">
                <div class="pt pl pb pr text-center">回收站（个）</div>
                <div class="text-center font-3x text-muted" :class="{ 'text-danger': recycle > 0 }" role="button" style="height: 113px; padding-top: 20px;" @click="toBin">{{ recycle }}</div>
              </div>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card v-loading="loading" shadow="never">
          <div class="front-line mb">充值概览</div>
          <el-row :gutter="15">
            <el-col :span="12">
              <div class="bg-light radius5">
                <div class="pt pl pb pr text-center">购物车（个）</div>
                <div class="text-center font-3x text-muted" :class="{ 'text-success': stat.cart_total > 0 }" role="button" style="height: 113px; padding-top: 20px;" @click="$router.push('/ap/recharge/cart')">{{ stat.cart_total }}</div>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="bg-light radius5">
                <div class="pt pl pb pr text-center">充值记录（个）</div>
                <div class="text-center font-3x text-muted" :class="{ 'text-success': stat.order_total > 0 }" role="button" style="height: 113px; padding-top: 20px;" @click="$router.push('/ap/recharge/order')">{{ stat.order_total }}</div>
              </div>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
    </el-row>

    <el-card class="no-header-line mt-md" shadow="never">
      <div slot="header" class="clearfix">
        <span class="front-line">接入点整体状况</span>
      </div>
      <ap-overview-chart />
    </el-card>
  </div>
</template>

<script>
const today = new Date(new Date().toLocaleDateString()).getTime()

import ApOverviewChart from './components/ApOverviewChart'
import { apHomeStatApi, apRecycleStatApi } from '@/api/ap/apApi'
import { apCartExpiredApi } from '@/api/ap/apRechargeApi'
export default {
  components: {
    ApOverviewChart
  },
  data() {
    return {
      loading: false,
      stat: {
        total_num: null,
        expired: null,
        expired_in_thirty_days: null,
        expired_in_ninety_days: null,
        cart_total: null,
        order_total: null
      },
      recycle: 0
    }
  },
  computed: {
    oneMonth() {
      return (today + 3600 * 1000 * 24 * 30) / 1000
    },
    threeMonth() {
      return (today + 3600 * 1000 * 24 * 90) / 1000
    }
  },
  created() {
    this.fetchData()
    this.fetchRecycle()
  },
  methods: {
    fetchData() {
      this.loading = true
      apHomeStatApi().then(res => {
        this.loading = false
        if (!res.errno) {
          this.stat = Object.assign({}, res.data)
        } else {
          this.$message.error(res.message)
        }
      })
    },
    fetchRecycle() {
      apRecycleStatApi().then(res => {
        if (!res.errno) {
          this.recycle = res.data.total
        } else {
          this.$message.error(res.message)
        }
      })
    },
    rechargeExpired() {
      apCartExpiredApi().then(res => {
        if (res.errno === 0) {
          this.$router.push('/ap/recharge/cart')
        } else {
          this.$message.error(res.message)
        }
      })
    },
    toBin() {
      this.$router.push('/ap/list?recycle_bin=true')
    }
  }
}
</script>

<style lang="scss" scoped>
.block-item {
  padding: 10px 20px;
  .title {
    display: inline-block;
    width: 130px;
    color: #666;
  }
}
</style>
